import { getCurrentInstance } from 'vue';

export function useGlobalPlugins() {
  const instance = getCurrentInstance();

  if (!instance) {
    throw new Error('useGlobalPlugins must be called inside a setup function');
  }

  const { $bus, $alert, $modal, $moment } = instance.proxy;

  return {
    $bus,
    $alert,
    $modal,
    $moment,
  };
}
